module.exports = __webpack_public_path__ + "media/customizations/regencyatmilestoneranch/back-49359c20e5a849939947591e131329da.jpg";